import { useQuery, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { API_URL } from '@/config';

export const getDownloadWorkflow = async (project_id: string, file_id: string): Promise<any> => {
  const access_token = storage.getToken();

  if (!access_token || !project_id || !file_id) {
    return;
  }

  try {
    const response: any = await axios.get(
      `${API_URL}/v2/project/${project_id}/contents/file/${file_id}/download`
    );

    return response;
  } catch (error) {
    // console.error('Error fetching ', error);
    // throw error;
  }
};

export const useGetDownloadWorkflow = (project_id: string, file_id: string, config = {}) => {
  const { addNotification } = useNotificationStore();

  return useQuery<any, Error>(
    ['downloadFile', project_id, file_id],
    () => getDownloadWorkflow(project_id, file_id),
    {
      onError: (error) => {
        addNotification({
          type: 'error',
          title: 'Failed to download file',
          message: error.message,
        });
      },
      onSuccess: (data) => {},
      ...config,
    }
  );
};

export const useInvalidateDownloadFile = () => {
  const queryClient = useQueryClient();

  return (project_id: string, file_id: string) => {
    queryClient.invalidateQueries(['downloadFile', project_id, file_id]);
  };
};
